import _ from 'lodash';
import { getValues } from 'redux-form';
import { put, take, select } from 'redux-saga/effects';

import { MY_ACCOUNTS_STEP_ID } from '@src/containers/Routes/helper/stepActiveIds.helper';

import { buildApplicationState } from '../../helpers/applicationManager';

// TODO: Move this closer to the API/Application layer.
export function* saveCustomerState(nextStepId) {
    const { application, formValues, ui } = yield select((state) => ({
        formValues: getValues(state.form.sign_up),
        application: state.fetched.application,
        ui: state.ui
    }));

    const newStep = nextStepId || ui.activeStep.id;
    const newState = buildApplicationState(application.payload, formValues);
    const newFurthestStep =
        nextStepId === MY_ACCOUNTS_STEP_ID
            ? {
                  id: MY_ACCOUNTS_STEP_ID,
                  name: 'My Account'
              }
            : ui.furthestStep;

    yield put({
        type: 'SAVE_CUSTOMER_STATE_REQUESTED',
        state: {
            data: {
                application: _.merge({}, newState),
                ui: _.merge({}, ui, {
                    activeStep: _.find(ui.steps, { id: `${newStep}` }),
                    furthestStep: newFurthestStep
                })
            }
        }
    });

    const stateStatus = yield take([
        'SAVE_CUSTOMER_STATE_SUCCEED',
        'SAVE_CUSTOMER_FAILED'
    ]);

    return stateStatus;
}
